import * as React from "react";
import Home from "./Home";
import "../css/App.css";

export default function IndexPage() {
  return (
    <>
      <title>{"FERNANDO LEYRA | actor & artist"}</title>
      <Home />
    </>
  );
}
